export const mapAccountDetails = (response: any) => {
  const data = response.data;

  return {
    name: [data.clientname, data.orgname, data.yachtname],
    rank: `${data.rolename}`,
    signature: {
      image: `${data.content.account.signature}`,
      dateUploaded: {
        lt: data.content.account.sigdateLT,
        utc: data.content.account.sigdate,
      },
    },
    form: {
      clientid: `${data.clientid}`,
      userid: `${data.userid}`,
      fname: `${data.content.account.firstname}`,
      sname: `${data.content.account.surname}`,
      email: `${data.content.account.email}`,
      personalEmail: `${data.content.account.personalEmail || ""}`,
      phoneno: `${data.content.account.phoneno}`,
      mobile: `${data.content.account.mobile}`,
      dssToken: `${data.content.account.dssToken || ""}`,
      dssJoinedDate: `${data.content.account.dssJoinedDate || ""}`,
      dssActive: !!data.content.account.dssActive || false,
    },
  };
};
